//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    collect: {
      type: String,
      default: "0",
    },
    invite: {
      type: String,
      default: "0",
    },
    buy: {
      type: String,
      default: "0",
    },
    id: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    isExpert:{
      default: "0",
    },
    create:{
      type: String,
      default: "",
    }
  },
  data: function () {
    return {
        isCollect:'0', //0是未收藏  1是已收藏
        dialogVisible:false, 
        traProjectId:'',
        projectInfo:'',
        userType:'',
        userId:''
    };
  },

  methods: {
    // 检测是否收藏
    checkCollect(){
        let params = {
            relationId: this.$route.query.id
          }
        this.$get('/sys/user/collect/isCollect',params,function(res){
            if(res.code==200){
                this.isCollect = res.data
            }
        })
    },
    //收藏
    collectSuc() {
        if(!getSession('user').id){
          this.$confirm('当前还未登录,登录后才可操作','提示',{
            confirmButtonText:'去登录',
            type:'info'
          }).then(()=>{
            this.$router.push({
              path:'/login?logins=1'
            })
          })
          return
        }
        this.$post('/sys/user/collect',{
            collectType: this.type,
            relationId: this.id
        },function(res){
            if(res.code==200){
                this.$message.success('收藏成功')
                this.checkCollect()
            }
        },true)
    },
    // 取消收藏
    collectCel(){
        this.$confirm('确定要取消收藏吗','提示',{
            confirmButtonText:'确定',
            cancelButtonText:'取消',
            type:'warning'
        }).then(()=>{
            this.$put('/sys/user/collect?ids='+this.id,'',function(res){
                if(res.code==200){
                    this.$message.success('取消成功')
                    this.checkCollect()
                }
            },true)
        })
    },
    //邀请专家参与项目
    invitePerson() {
        this.dialogVisible = true;
        this.getProjectInfo();
    },

    // 获取项目列表
    getProjectInfo(){
        let params = {
          pageIndex: this.pageIndex,
          pageSize: 6,
          title: '',
          sortName: '',
          sortOrder: 'asc',
          projectStatus: '2',
          userType:this.isExpert,
          type:1
        }
        this.$get('/tra/project/list',params,function(res){
            if(res.code==200){
                this.projectInfo = res.data.records
            }
        })
    },

    // 确定邀请
    ensurePerson(){
        var arr=[]
        arr.push(this.$route.query.id)
        this.$post('/tra/project/bid/invitation',{
            traProjectId:this.traProjectId,
            userIds:arr,
        },function(res){
            if(res.code==200){
                this.dialogVisible = false
            }
        },true)
    },

    // 沟通询价(购买商品)
    buyProduct(){

    },

    //联系专家
    linkPerson(){
      this.$router.push({
        path:'/release/index?releaseType=1&userId='+this.$route.query.id
      })
    },
  },
  mounted: function () {
    this.userType = getSession('user').currentUserType
    this.userId= getSession('user').id
    if(getSession('user')){
        this.checkCollect()
    }
  },
};
